class GiftWrapDrawer extends HTMLElement {
    constructor() {
        super();
        const currentElement = this;

        this.querySelector('#giftWrapDrawer-Overlay').addEventListener('click', this.close.bind(this));

        document.addEventListener('DOMContentLoaded', function () {
            var addMessageCheckbox = document.getElementById('gift-wrap-add-message');

            addMessageCheckbox.addEventListener('change', function (event) {
                event.preventDefault();
                var element = this.closest('gift-wrap-drawer').querySelector('.gift-wrap-message-fieldset');
                if (element.classList.contains('applied')) {
                    element.classList.remove('applied');
                }
                else {
                    element.classList.add('applied');
                }
            });

            var removeGiftWrap = document.getElementById('remove-gift-wrap');

            removeGiftWrap.addEventListener('click', function (event) {
                event.preventDefault();
                currentElement.removeGiftWrap();
            });

            const giftWrapRadioButtons = document.querySelectorAll('input[name="properties[gift-wrap-color]"]');

            giftWrapRadioButtons.forEach(function (button) {
                button.addEventListener('click', function () {
                    currentElement.validateColor();
                });
            });


            // Add an event listener to the document for clicks
            document.addEventListener('click', function (event) {
                if (event.target.closest('.make-a-gift-cta')) {
                    const button = event.target.closest('.make-a-gift-cta');
                    const closestGiftWrapDrawer = document.getElementById("gift-wrap-drawer");
                    currentElement.setActiveElement(button);
                    document.getElementById('gift-wrap-error').classList.remove('active');
                    if (closestGiftWrapDrawer.classList.contains('active')) {
                        closestGiftWrapDrawer.classList.remove('active');
                        document.body.classList.remove('overflow-hidden');
                    } else {
                        closestGiftWrapDrawer.classList.add('active');
                        document.body.classList.add('overflow-hidden');
                    }
                    let position = button.getAttribute('data-position');

                    if (position != null) {
                        const apiUrl = '/cart.js';

                        // Fetching data from the API
                        fetch(apiUrl)
                            .then(response => {
                                // Check if the response is successful
                                if (!response.ok) {
                                    throw new Error('Network response was not ok');
                                }
                                // If the response is successful, parse the JSON data
                                return response.json();
                            })
                            .then(data => {
                                // Do something with the data
                                console.log(data.items);
                                var items = data.items;
                                var properties = items[position].properties;
                                currentElement.setKey(items[position].key);

                                if (properties["gift-wrap-add-message"] != 'on' && properties["gift-wrap-add-message"] == null) {
                                    currentElement.clearFormFields();
                                }
                                // Get the radio button elements
                                const radioButtons = document.querySelectorAll('input[name="properties[gift-wrap-color]"]');

                                // Loop through the radio buttons to find the one with the value and check it
                                radioButtons.forEach(radioButton => {
                                    if (radioButton.value === properties["gift-wrap-color"]) {
                                        radioButton.checked = true;
                                    } else {
                                        radioButton.checked = false; // Uncheck the other radio buttons
                                    }
                                });
                                console.log(properties["gift-wrap-color"]);
                                if (properties["gift-wrap-add-message"] == 'on') {
                                    var element = document.getElementById('gift-wrap-message-fieldset');
                                    element.classList.add('applied');
                                    document.getElementById("gift-wrap-add-message").checked = true
                                    document.getElementById("gift-wrap-from").value = properties["gift-wrap-from"];
                                    document.getElementById("gift-wrap-to").value = properties["gift-wrap-to"];
                                    document.getElementById("gift-wrap-message").value = properties["gift-wrap-message"];
                                }
                            })
                            .catch(error => {
                                // Handle any errors that occur during the fetch request
                                console.error('There has been a problem with your fetch operation:', error);
                            });
                    }
                }
            });


            // Define the click function
            const closeModal = (event) => {
                event.preventDefault();
                document.getElementById('myModal').style.display = 'none';
            };

            var cancelButton = document.getElementById("gift-wrap-cancel");
            cancelButton.addEventListener("click", closeModal);

            var span = document.getElementsByClassName("close")[0];
            span.addEventListener("click", closeModal);
            // Get all elements with the class name 'make-a-gift-clear'
            // const clearButtons = document.querySelectorAll('.make-a-gift-clear');

            // // Iterate over each 'make-a-gift-clear' element and add a click event listener
            // clearButtons.forEach(clearButton => {

            //     clearButton.addEventListener('click', function () {
            //         debugger;
            //         // Get the corresponding 'make-a-gift-cta' element based on the structure of your HTML
            //         const parentDiv = clearButton.parentNode;
            //         const makeAGiftCTA = parentDiv.querySelector('.make-a-gift-cta');
            //         currentElement.setActiveElement(makeAGiftCTA);
            //         const closestModal = document.getElementById("myModal");
            //         closestModal.style.display = "flex";
            //     });
            // });
            document.addEventListener('click', function (event) {
                const clearButton = event.target.closest('.make-a-gift-clear');
                if (clearButton) {
                    if (event.target.classList.contains('remove-gift-wrap')) {
                        clearButton.parentNode.remove();
                    } else {
                        const parentDiv = clearButton.parentNode;
                        const makeAGiftCTA = parentDiv.querySelector('.make-a-gift-cta');
                        currentElement.setActiveElement(makeAGiftCTA);
                        const closestModal = document.getElementById("myModal");
                        closestModal.style.display = "flex";
                    }
                }
            });


            const giftWrapUpdateButtons = document.querySelectorAll('.gift-wrap-update');

            giftWrapUpdateButtons.forEach(function (button) {
                button.addEventListener('click', function (event) {
                    console.log(currentElement.activeElement);
                    event.preventDefault();
                    // const makeGiftClearElement = this.closest('.gift-wrap-drawer').previousElementSibling.querySelector('.make-a-gift-clear');
                    if (!currentElement.validateColor()) {
                        return false;
                    }
                    const makeGiftCtaElement = currentElement.activeElement;
                    makeGiftCtaElement.querySelector('.make-a-gift-text').innerHTML = 'MODIFY GIFT';
                    makeGiftCtaElement.parentNode.querySelector('.make-a-gift-cta-icon').classList.add('applied');
                    makeGiftCtaElement.parentNode.querySelector('.make-a-gift-clear').classList.add('applied');

                    const giftWrapDrawer = this.closest('.gift-wrap-drawer');
                    const fromInput = giftWrapDrawer.querySelector('.gift-wrap-from');
                    const toInput = giftWrapDrawer.querySelector('.gift-wrap-to');
                    const messageInput = giftWrapDrawer.querySelector('textarea[name="properties[gift-wrap-message]"]');
                    const colorInputs = giftWrapDrawer.querySelectorAll('input[type="radio"][name="properties[gift-wrap-color]"]');
                    const addMessageInput = giftWrapDrawer.querySelector('input[name="properties[gift-wrap-add-message]"]');
                    const productKey = giftWrapDrawer.querySelector('.product-key').value;

                    if (addMessageInput.value != "on") {
                        var element = document.getElementById('gift-wrap-message-fieldset');
                        element.classList.remove('applied');
                    }
                    var selectedColor;
                    colorInputs.forEach(function (input) {
                        console.log(input);
                        if (input.checked) {
                            selectedColor = input.value;
                        }
                    });
                    const cartUrl = '/cart.js';

                    fetch(cartUrl)
                        .then(response => {
                            // Check if the response is successful
                            if (!response.ok) {
                                throw new Error('Network response was not ok');
                            }
                            // If the response is successful, parse the JSON data
                            return response.json();
                        })
                        .then(data => {

                            // Check if the response is successful
                            var item = data.items;
                            var properties = data.items.properties;
                            var xhr = new XMLHttpRequest();
                            xhr.open('POST', '/cart/change.js', true);
                            xhr.setRequestHeader('Content-Type', 'application/json');
                            xhr.onreadystatechange = function () {
                                if (xhr.readyState === 4 && xhr.status === 200) {
                                    var cart = JSON.parse(xhr.responseText);

                                    // handle the 'cart' object in the success callback as needed
                                }
                            };
                            var data = JSON.stringify({


                                id: currentElement.currentItemKey, properties: {
                                    'gift-wrap-color': selectedColor,
                                    'gift-wrap-add-message': addMessageInput.value,
                                    'gift-wrap-from': fromInput.value,
                                    'gift-wrap-to': toInput.value,
                                    'gift-wrap-message': messageInput.value,
                                    '1': data.items[0].properties[1],
                                    '2': data.items[0].properties[2],
                                    '3': data.items[0].properties[3],
                                    '4': data.items[0].properties[4]

                                }
                            });

                            xhr.send(data);
                        })

                    if (giftWrapDrawer.classList.contains('active')) {
                        giftWrapDrawer.classList.remove('active');
                        document.body.classList.remove('overflow-hidden');
                    } else {
                        giftWrapDrawer.classList.add('active');
                        document.body.classList.add('overflow-hidden');
                    }


                });
            });

        }, false);
    }

    validateColor() {
        const colorInputs = this.querySelectorAll('input[type="radio"][name="properties[gift-wrap-color]"]');
        var selectedColor = "";
        colorInputs.forEach(function (input) {
            if (input.checked) {
                selectedColor = input.value;
            }
        });
        if (!selectedColor) {
            document.getElementById('gift-wrap-error').classList.add('active');
            return false;
        } else {
            document.getElementById('gift-wrap-error').classList.remove('active');
            return true;
        }
    }

    clearFormFields() {
        document.getElementById("gift-wrap-add-message").checked = false;
        document.getElementById("gift-wrap-from").value = '';
        document.getElementById("gift-wrap-to").value = '';
        document.getElementById("gift-wrap-message").value = '';
        var radioButtons = this.querySelectorAll("input[type='radio']");
        radioButtons.forEach(function (radio) {
            radio.checked = false;
        });
        document.getElementById("gift-wrap-message-fieldset").classList.remove('applied');
    }

    close() {
        this.classList.remove('active');
        removeTrapFocus(this.activeElement);
        document.body.classList.remove('overflow-hidden');
        if (!this.validateColor()) {
            this.clearFormFields();
            document.getElementById('gift-wrap-error').classList.remove('active');
        }
    }

    setActiveElement(element) {
        this.activeElement = element;
    }

    setKey(key) {
        this.currentItemKey = key;
    }

    removeGiftWrap() {
        this.clearFormFields();

        if (this.classList.contains('active')) {
            this.classList.remove('active');
            document.body.classList.remove('overflow-hidden');
        }
        document.getElementById('myModal').style.display = 'none';
        const makeGiftCtaElement = this.activeElement;
        // Perform further actions with makeGiftClearElement

        makeGiftCtaElement.querySelector('.make-a-gift-text').innerHTML = 'Make it a gift';
        makeGiftCtaElement.parentNode.querySelector('.make-a-gift-cta-icon').classList.remove('applied');
        makeGiftCtaElement.parentNode.querySelector('.make-a-gift-clear').classList.remove('applied');

        let position = makeGiftCtaElement.getAttribute('data-position');

        if (position != null) {
            const apiUrl = '/cart.js';


            // Fetching data from the API
            fetch(apiUrl)
                .then(response => {
                    // Check if the response is successful
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    // If the response is successful, parse the JSON data
                    return response.json();
                })
                .then(data => {
                    // Do something with the data
                    var items = data.items;
                    var xhr = new XMLHttpRequest();
                    xhr.open('POST', '/cart/change.js', true);
                    xhr.setRequestHeader('Content-Type', 'application/json');
                    xhr.onreadystatechange = function () {
                        if (xhr.readyState === 4 && xhr.status === 200) {
                            var cart = JSON.parse(xhr.responseText);
                            // handle the 'cart' object in the success callback as needed
                        }
                    };
                    var giftWrapData = JSON.stringify({
                        id: items[position].key, properties: {
                            'gift-wrap-color': null,
                            'gift-wrap-add-message': null,
                            'gift-wrap-from': null,
                            'gift-wrap-to': null,
                            'gift-wrap-message': null,
                            '1': data.items[0].properties[1],
                            '2': data.items[0].properties[2],
                            '3': data.items[0].properties[3],
                            '4': data.items[0].properties[4]

                        }
                    });
                    xhr.send(giftWrapData);

                })
                .catch(error => {
                    // Handle any errors that occur during the fetch request
                    console.error('There has been a problem with your fetch operation:', error);
                });
        }
    }
}

customElements.define('gift-wrap-drawer', GiftWrapDrawer);

